// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Castro from '../../../Texas/data/counties/Castro.geo.json'
import Bailey from '../../../Texas/data/counties/Bailey.geo.json'
import Lamb from '../../../Texas/data/counties/Lamb.geo.json'
import Hale from '../../../Texas/data/counties/Hale.geo.json'
import Floyd from '../../../Texas/data/counties/Floyd.geo.json'
import Motley from '../../../Texas/data/counties/Motley.geo.json'
import Cottle from '../../../Texas/data/counties/Cottle.geo.json'
import Cochran from '../../../Texas/data/counties/Cochran.geo.json'
import Hockley from '../../../Texas/data/counties/Hockley.geo.json'
import Lubbock from '../../../Texas/data/counties/Lubbock.geo.json'
import Crosby from '../../../Texas/data/counties/Crosby.geo.json'
import Dickens from '../../../Texas/data/counties/Dickens.geo.json'
import King from '../../../Texas/data/counties/King.geo.json'
import Yoakum from '../../../Texas/data/counties/Yoakum.geo.json'
import Terry from '../../../Texas/data/counties/Terry.geo.json'
import Lynn from '../../../Texas/data/counties/Lynn.geo.json'
import Garza from '../../../Texas/data/counties/Garza.geo.json'
import Kent from '../../../Texas/data/counties/Kent.geo.json'
import Gaines from '../../../Texas/data/counties/Gaines.geo.json'
import Dawson from '../../../Texas/data/counties/Dawson.geo.json'
import Borden from '../../../Texas/data/counties/Borden.geo.json'
import Scurry from '../../../Texas/data/counties/Scurry.geo.json'

const counties = {
  Castro,
  Bailey,
  Lamb,
  Hale,
  Floyd,
  Motley,
  Cottle,
  Cochran,
  Hockley,
  Lubbock,
  Crosby,
  Dickens,
  King,
  Yoakum,
  Terry,
  Lynn,
  Garza,
  Kent,
  Gaines,
  Dawson,
  Borden,
  Scurry
}

export default counties
